// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.EmailMultiSelect_input__ELg43 input {
  margin-bottom: 8px;
  min-width: 150px !important;
}
.EmailMultiSelect_input__ELg43 > div {
  min-height: 43px;
  padding-bottom: 0 !important;
}
.EmailMultiSelect_input__mail__ppSJd {
  height: 24px !important;
  width: 24px !important;
  align-self: flex-start;
}

.EmailMultiSelect_input__warning__6vh5i {
  font-family: Roboto, serif;
  font-size: 12px;
  font-weight: 400;
  line-height: 14px;
  letter-spacing: 0;
  color: #E59F42;
  padding: 4px 0;
  margin-top: 4px;
}

.EmailMultiSelect_input__error__x3-j4 {
  font-family: Roboto, serif;
  font-size: 12px;
  font-weight: 400;
  line-height: 14px;
  letter-spacing: 0;
  color: #E23834;
  padding: 4px 0;
  margin-top: 4px;
}

.EmailMultiSelect_tagEmail__iHjR3 {
  display: flex;
  align-items: center;
  padding: 0 8px 0 12px;
  background: #F7F7F7;
  border: 1px solid #F7F7F7;
  border-radius: 100px;
  margin-right: 8px;
  margin-bottom: 8px;
}
.EmailMultiSelect_tagEmail__text__S5Avk {
  word-break: break-all;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  display: -webkit-box;
  font-family: Roboto, serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 16px;
  letter-spacing: 0;
  text-align: left;
  color: #272A36;
}
.EmailMultiSelect_tagEmail__icon__1h1uO {
  cursor: pointer;
  padding-left: 8px;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.EmailMultiSelect_tagEmail__iHjR3.EmailMultiSelect_warning__v-xJF {
  background: #FDF7F0;
  border: 1px solid #E59F42;
}
.EmailMultiSelect_tagEmail__iHjR3.EmailMultiSelect_warning__v-xJF .EmailMultiSelect_tagEmail__text__S5Avk {
  color: #E59F42;
}
.EmailMultiSelect_tagEmail__iHjR3.EmailMultiSelect_error__UPOfR {
  background: #FDEFEF;
  border: 1px solid #E23834;
}
.EmailMultiSelect_tagEmail__iHjR3.EmailMultiSelect_error__UPOfR .EmailMultiSelect_tagEmail__text__S5Avk {
  color: #E23834;
}`, "",{"version":3,"sources":["webpack://./src/components/ui/fields/EmailMultiSelect/EmailMultiSelect.module.scss"],"names":[],"mappings":"AACE;EACE,kBAAA;EACA,2BAAA;AAAJ;AAEE;EACE,gBAAA;EACA,4BAAA;AAAJ;AAEE;EACE,uBAAA;EACA,sBAAA;EACA,sBAAA;AAAJ;;AAIA;EACE,0BAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;EACA,cAAA;EACA,cAAA;EACA,eAAA;AADF;;AAIA;EACE,0BAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;EACA,cAAA;EACA,cAAA;EACA,eAAA;AADF;;AAIA;EACE,aAAA;EACA,mBAAA;EACA,qBAAA;EACA,mBAAA;EACA,yBAAA;EACA,oBAAA;EACA,iBAAA;EACA,kBAAA;AADF;AAEE;EACE,qBAAA;EACA,gBAAA;EACA,uBAAA;EACA,qBAAA;EACA,4BAAA;EACA,oBAAA;EACA,0BAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;AAAJ;AAEE;EACE,eAAA;EACA,iBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAAJ;AAEE;EACE,mBAAA;EACA,yBAAA;AAAJ;AACI;EACE,cAAA;AACN;AAEE;EACE,mBAAA;EACA,yBAAA;AAAJ;AACI;EACE,cAAA;AACN","sourcesContent":[".input {\n  & input {\n    margin-bottom: 8px;\n    min-width: 150px !important;\n  }\n  & > div {\n    min-height: 43px;\n    padding-bottom: 0 !important;\n  }\n  &__mail {\n    height: 24px !important;\n    width: 24px !important;\n    align-self: flex-start;\n  }\n}\n\n.input__warning {\n  font-family: Roboto, serif;\n  font-size: 12px;\n  font-weight: 400;\n  line-height: 14px;\n  letter-spacing: 0;\n  color: #E59F42;\n  padding: 4px 0;\n  margin-top: 4px;\n}\n\n.input__error {\n  font-family: Roboto, serif;\n  font-size: 12px;\n  font-weight: 400;\n  line-height: 14px;\n  letter-spacing: 0;\n  color: #E23834;\n  padding: 4px 0;\n  margin-top: 4px;\n}\n\n.tagEmail {\n  display: flex;\n  align-items: center;\n  padding: 0 8px 0 12px;\n  background: #F7F7F7;\n  border: 1px solid #F7F7F7;\n  border-radius: 100px;\n  margin-right: 8px;\n  margin-bottom: 8px;\n  &__text {\n    word-break: break-all;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    -webkit-line-clamp: 1;\n    -webkit-box-orient: vertical;\n    display: -webkit-box;\n    font-family: Roboto, serif;\n    font-size: 14px;\n    font-weight: 400;\n    line-height: 16px;\n    letter-spacing: 0;\n    text-align: left;\n    color: #272A36;\n  }\n  &__icon {\n    cursor: pointer;\n    padding-left: 8px;\n    width: 24px;\n    height: 24px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n  &.warning {\n    background: #FDF7F0;\n    border: 1px solid #E59F42;\n    .tagEmail__text {\n      color: #E59F42;\n    }\n  }\n  &.error {\n    background: #FDEFEF;\n    border: 1px solid #E23834;\n    .tagEmail__text {\n      color: #E23834;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"input": `EmailMultiSelect_input__ELg43`,
	"input__mail": `EmailMultiSelect_input__mail__ppSJd`,
	"input__warning": `EmailMultiSelect_input__warning__6vh5i`,
	"input__error": `EmailMultiSelect_input__error__x3-j4`,
	"tagEmail": `EmailMultiSelect_tagEmail__iHjR3`,
	"tagEmail__text": `EmailMultiSelect_tagEmail__text__S5Avk`,
	"tagEmail__icon": `EmailMultiSelect_tagEmail__icon__1h1uO`,
	"warning": `EmailMultiSelect_warning__v-xJF`,
	"error": `EmailMultiSelect_error__UPOfR`
};
export default ___CSS_LOADER_EXPORT___;
